module.exports = __webpack_public_path__ + "img/national-flight-academy.58e11bdf.png";